/**
 * Polyfills
 */
import 'nodelist-foreach-polyfill';
import 'classlist-polyfill';
import 'custom-event-polyfill';
import 'whatwg-fetch';
import 'element-remove';
import 'intersection-observer';
import 'polyfill-array-includes';

//import arrayFrom      from 'array-from';
//import clementClosest from 'element-closest';
//clementClosest(window);
//if (!Array.from) Array.from = arrayFrom;
import Cursor               from './classes/Cursor';
import Inview             from './classes/Inview';
import Pluton             from 'whitecube-pluton';



class Ecta {
    constructor() {
        this.parts = new Pluton();
        this.inview = Inview;
        //this.cursor = new Cursor();
    }
}

window.addEventListener("load", function(event) {
    window.Ecta = new Ecta();
});


window.initMap = () => {
    window.dispatchEvent(new CustomEvent('ecta-mapsloaded'));
    window.mapsLoaded = true;
}


window.initCountry = () => {
    console.log('initCountry');
}
/*
window.onYouTubeIframeAPIReady = () => {
    window.dispatchEvent(new CustomEvent('ecta-youtubeloaded'));
    window.youtubeLoaded = true;
}*/